/**
 * Global SVG filter defs for the iOS 26 "Liquid Glass" refraction.
 * Mount once at the app root. Referenced by `.glass-panel*` utilities
 * via `backdrop-filter: url(#liquid-glass)`.
 */
export const LiquidGlassFilter = () => (
  <svg
    aria-hidden="true"
    style={{ position: 'fixed', width: 0, height: 0, pointerEvents: 'none' }}
  >
    <defs>
      <filter id="liquid-glass" x="-50%" y="-50%" width="200%" height="200%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.008 0.012"
          numOctaves="2"
          seed="7"
          result="noise"
        />
        <feGaussianBlur in="noise" stdDeviation="2" result="blurNoise" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="blurNoise"
          scale="18"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <filter id="liquid-glass-soft" x="-50%" y="-50%" width="200%" height="200%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.015 0.02"
          numOctaves="1"
          seed="3"
          result="noise"
        />
        <feDisplacementMap
          in="SourceGraphic"
          in2="noise"
          scale="10"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </defs>
  </svg>
);

export default LiquidGlassFilter;
